export type WidgetCatalogItem = {
  key: string;
  label: string;
  scope: string;
  requiredService?: string | null;
};

export const WIDGET_SCOPE_PRODUTOS_GERAL = "produtos-geral";

export const WIDGET_CATALOG: WidgetCatalogItem[] = [
  {
    key: "coordination",
    label: "Credenciamento",
    scope: WIDGET_SCOPE_PRODUTOS_GERAL,
    requiredService: "COORDENACAO",
  },
  {
    key: "pipeline_kpis",
    label: "Indicadores de credenciamento",
    scope: WIDGET_SCOPE_PRODUTOS_GERAL,
    requiredService: "COORDENACAO",
  },
  {
    key: "attendance_kpis",
    label: "Atendimentos",
    scope: WIDGET_SCOPE_PRODUTOS_GERAL,
    requiredService: "COORDENACAO",
  },
  {
    key: "engagement_kpis",
    label: "Engajamento",
    scope: WIDGET_SCOPE_PRODUTOS_GERAL,
    requiredService: null,
  },
];
